import Footer from "../../component/Footer";
import { useState } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import { useNavigate } from "react-router-dom";
import RechargeNavbar from "./AgentComp/RechargeNavbar";

function RechargeMoneyTransfer() {
  const [mobileNumber, setMobileNumber] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!/^[0-9]{10}$/.test(mobileNumber)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    const searchParams = new URLSearchParams({ mobile: mobileNumber }).toString();
    navigate(`/remitter-check?${searchParams}`);
  };

  return (
    <>
      <AgentNavbar />
      <div className="bgsearch1">
        <div className="container bg-2 midle">
          <RechargeNavbar />
          <h1 className="text-start agenth1 font3 txt6">Money Transfer</h1>
          <hr />

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3 text-start mb-3">
              {/* Mobile Number Field */}
              <div className="col-md-6 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Registered Mobile Number</label>
                <input
                  type="tel"
                  className="input2"
                  name="mobileNumber"
                  placeholder="Enter Registered Mobile Number"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  required
                />
              </div>
            </div>

            <div>
              <button type="submit" className="submit-btn mt-3">
                Check Remitter Registration
              </button>
            </div>
          </form>

          <hr className="mt-4" />
          <p>Enter the registered mobile number to check remitter status and proceed with money transfer.</p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RechargeMoneyTransfer;
